import React, { useEffect, useState } from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import Header from './../components/header';
import Footer from './../components/footer';
import SEOTags from './../common/SEO';
import PersonalInjuryBanner from './../assets/img/banner/personal-injury.jpg';

import { Link, useLocation } from 'react-router-dom';

const PersonalInjury = () => {
    const [videoLoaded, setVideoLoaded] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const loadVideo = () => {
        setVideoLoaded(true);
    };
    useEffect(() => {
        SEOTags(
            "Personal Injury | Figgers Law",
        );
    }, [])
    return (
        <>

            <Header></Header>
            <section style={{
                backgroundImage: isMobile
                    ? `linear-gradient(rgba(0,0,0,.6), rgba(0,0,0,.6)), url(${PersonalInjuryBanner})`
                    : `url(${PersonalInjuryBanner})`,
                backgroundSize: "cover",
                backgroundPosition: "right",
            }}
                className="sub-hero pa-hero">
                <div className="container">
                    <div className="section-label">Practice Area</div>

                    <h1>Personal Injury</h1>

                    <p>
                        Comprehensive legal support for individuals harmed due to
                        negligence.
                    </p>
                    <div
                        style={{
                            marginTop: "20px",
                            display: "flex",
                            gap: "12px",
                            flexWrap: "wrap",
                        }}
                    >
                        <Link to={'/contact-us'} className="btn-gold">
                            Free Consultation
                        </Link>

                        <a href="tel:+8556435291" className="btn-outline-ivory">
                            Call (855) 643-5291
                        </a>
                    </div>
                </div>
            </section>

            {/* Body */}
            <section className="sub-body alt">
                <div className="container">
                    <div className="pa-grid">
                        <div className="sub-content">

                            <div className='businesslaw_head'>


                                <h3>Getting injured sucks, but not getting paid for it is worse.</h3>

                                <p>
                                    We can turn your Pain into gain.
                                </p>

                                <p>
                                    <strong style={{ color: '#D5B269' }}>At Figgers Law, we treat our clients like family.</strong>
                                </p>

                            </div>

                            <h2>Injured at a business, on commercial property, or by a company vehicle?</h2>

                            <p>One moment can change everything.
                                You are dealing with pain, medical appointments, missed work, bills, and questions you never expected to have to answer.
                                Meanwhile, the business or insurance company on the other side may already have people working to protect its interests.
                                You deserve someone working just as hard to protect yours.
                            </p>

                            <p>
                                Figgers Law represents injured people and families throughout Florida, with a particular focus on cases involving businesses, commercial property, company vehicles, and other commercially insured defendants.
                                We do more than look at the person immediately involved.
                                We investigate the companies, property owners, management companies, contractors, fleet operators, security providers, and insurance coverage that may also be responsible.

                            </p>

                            <p>
                                And throughout the process, you are not just a file number.
                                We want to know what happened to you, how the injury has affected your life, what your family is dealing with, and what you need to move forward.

                            </p>
                            <h2>Was a Business Behind Your Injury?</h2>

                            <p>
                                A serious injury case can involve much more than one careless person.
                                If you were hurt at a business, apartment community, hotel, parking lot,
                                store, restaurant, entertainment venue, or by someone driving for work,
                                there may be one or more commercial defendants responsible for what happened.
                            </p>

                            <p>Figgers Law handles personal injury matters involving:</p>

                            <ul class="about-list">
                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Commercial vehicle crashes involving company cars, vans, trucks,
                                    delivery vehicles, service vehicles, construction vehicles, and fleet vehicles
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Tractor-trailer and trucking collisions
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Crashes involving drivers who were working, making deliveries,
                                    transporting passengers, or conducting company business
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Injuries at stores, shopping centers, restaurants, hotels,
                                    entertainment venues, and other businesses
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Injuries at apartment communities, condominiums, parking garages,
                                    parking lots, and common areas
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Negligent security claims involving shootings, assaults, robberies,
                                    and other violent incidents
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Falls and other injuries caused by unsafe property conditions,
                                    poor lighting, defective areas, or negligent maintenance
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Serious and catastrophic injuries caused by commercial negligence
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Wrongful death claims involving businesses or commercial defendants
                                </li>
                            </ul>


                            <h2>Commercial Vehicle &amp; Company Driver Cases</h2>

                            <p>
                                If the person who hit you was driving for work, the case may not end with
                                the driver. A company may own the vehicle, employ or contract with the
                                driver, control the route, maintain the vehicle, carry commercial insurance,
                                or have additional responsibility for how the vehicle was being used.
                            </p>

                            <p>
                                We look behind the vehicle to determine who was really operating the
                                business behind it. That investigation may include:
                            </p>

                            <ul class="about-list">
                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Who owned, leased, controlled, or maintained the vehicle
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Whether the driver was working or acting on behalf of a business
                                    at the time of the crash
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Commercial insurance policies and other available sources of coverage
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Driver qualification, training, supervision, and vehicle-use practices
                                    when relevant
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Maintenance, inspection, repair, dispatch, and fleet records
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    GPS information, electronic data, photographs, surveillance video,
                                    and other time-sensitive evidence
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Contracts and business relationships that may identify additional
                                    responsible companies
                                </li>
                            </ul>


                            <h2>Injured at a Store, Apartment Complex, Hotel, or Other Business?</h2>

                            <p>
                                You should be able to enter a business or property without being exposed
                                to an unreasonable danger. When a property is poorly maintained, improperly
                                managed, inadequately secured, or allowed to remain unsafe, the consequences
                                can be life-changing.
                            </p>

                            <p>
                                We investigate who controlled the property, who knew or should have known
                                about the danger, who was responsible for correcting it, and whether another
                                company was hired to maintain, manage, repair, or secure the premises.
                            </p>

                            <p>Depending on the facts, responsible parties may include:</p>

                            <ul class="about-list">
                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Property owners
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Businesses and commercial tenants
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Apartment or condominium owners and operators
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Property management companies
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Maintenance and repair contractors
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Security companies
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Developers, vendors, and other entities responsible for the condition
                                    or operation of the property
                                </li>
                            </ul>


                            <h2>Negligent Security</h2>

                            <p>
                                When someone is attacked, robbed, shot, or otherwise harmed on commercial
                                or residential property, the criminal who committed the act may not be the
                                only person responsible.
                            </p>

                            <p>
                                We investigate whether the owner, manager, business, or security provider
                                failed to take reasonable measures under the circumstances. That may include
                                reviewing prior criminal activity, police calls for service, incident reports,
                                gates and access-control systems, lighting, cameras, staffing, security
                                practices, and what the business knew before the incident occurred.
                            </p>

                            <p>
                                For our clients, these cases are personal. You may be recovering physically
                                while also dealing with fear, trauma, lost income, and a complete disruption
                                of your sense of safety. We take the time to understand all of it.
                            </p>


                            <h2>We Look Beyond the Obvious Defendant</h2>

                            <p>
                                One of the most important questions in a serious injury case is not simply,
                                "Who hurt you?" It is also, "Who had the power and legal responsibility to
                                prevent this from happening?"
                            </p>

                            <p>Depending on the facts, we may investigate:</p>

                            <ul class="about-list">
                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Businesses and corporate entities
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Property owners and management companies
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Commercial vehicle and fleet owners
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Employers, contractors, and subcontractors
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Security providers
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Companies responsible for maintenance, repair, or operations
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Commercial insurers and other applicable coverage
                                </li>
                            </ul>


                            <h2>Evidence Can Disappear. We Move Early.</h2>

                            <p>
                                Businesses often control evidence that an injured person cannot access on
                                their own, including surveillance footage, maintenance records, incident
                                reports, driver records, contracts, access-control data, internal
                                communications, and insurance information. Some of that evidence can be
                                overwritten, lost, or difficult to recover if action is not taken quickly.
                            </p>

                            <p>
                                Early investigation gives us the opportunity to identify potential
                                defendants, preserve important evidence, locate witnesses, obtain available
                                records, and understand the business relationships behind the injury.
                            </p>


                            <h2>Your Case Is About More Than a Claim Number</h2>

                            <p>
                                An injury can affect nearly every part of your life. Medical bills may be
                                only the beginning. You may be unable to work the same way, care for your
                                children the same way, sleep without pain, enjoy the things you used to
                                enjoy, or feel safe doing things that once felt routine.
                            </p>

                            <p>Depending on the facts and applicable law, damages may include:</p>

                            <ul class="about-list">
                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Past and future medical expenses
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Lost income and diminished earning capacity
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Future care and rehabilitation needs
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Physical pain and suffering
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Mental and emotional harm
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Permanent injury, impairment, scarring, or disfigurement
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Wrongful death damages when applicable
                                </li>
                            </ul>


                            <h2>At Figgers Law, We Treat Our Clients Like Family</h2>

                            <p>
                                That is not just a slogan to us. It means we want you to understand what
                                is happening in your case. We want your questions answered. We want to know
                                when something changes. And we want you to feel like the people handling
                                your case actually know you and care about what happens next.
                            </p>

                            <p>
                                We bring strategy to the case, but we do not lose sight of the person
                                behind it. We investigate the businesses, contracts, insurance, records,
                                and operational failures that caused or contributed to the injury while
                                staying focused on the very real impact the injury has had on you and your
                                family.
                            </p>


                            <h2>Let Us Help Turn Your Pain into Gain</h2>

                            <p>
                                You did not choose to be injured. You should not have to figure out the
                                legal system, commercial insurance, corporate defendants, and evidence
                                preservation by yourself.
                            </p>

                            <p>
                                <strong>
                                    Getting injured sucks, but not getting paid for it is worse.
                                </strong>
                                If a business, commercial property, company vehicle, or other commercial
                                defendant may have contributed to your injury, contact Figgers Law for a
                                confidential case evaluation. We will listen to what happened, evaluate
                                who may be responsible, and explain the next steps.
                            </p>

                        </div>

                        {/* Sidebar */}
                        <aside className="pa-sidebar">
                            <div className="pa-sidebar-card">
                                <h4>What We Can Help With</h4>

                                <ul className="pa-helps">
                                    <li>Medical bills and treatment costs</li>
                                    <li>Lost income and future earnings</li>
                                    <li>Pain and suffering damages</li>
                                    <li>Insurance claim negotiation</li>
                                    <li>Legal representation in court</li>
                                </ul>
                            </div>

                            <div className="pa-sidebar-cta">
                                <h4>Free Case Evaluation</h4>

                                <p>
                                    Speak directly with Natlie G. Figgers about your case — no
                                    cost, no obligation.
                                </p>

                                <Link to={'/contact-us'}
                                    className="btn-gold"
                                    style={{
                                        width: "100%",
                                        justifyContent: "center",
                                        marginTop: "12px",
                                    }}
                                >
                                    Request Free Review
                                </Link>
                            </div>

                            <div className="pa-sidebar-card">
                                <h4>No Upfront Fees</h4>

                                <p>
                                    Figgers Law works on a contingency fee basis. You pay nothing
                                    unless we recover compensation for you.
                                </p>
                            </div>
                        </aside>
                    </div>

                    {/* Related Practice Areas */}
                    <div className="pa-related">
                        <div className="section-label">Related Practice Areas</div>

                        <h2
                            className="font-display"
                            style={{ margin: "8px 0 20px" }}
                        >
                            Also Handled by Figgers Law
                        </h2>

                        <div className="pa-related-grid">
                            <Link
                                to="/rear-end-collision"
                                className="related-card"
                            >
                                <h4>Rear-End Collision</h4>

                                <p>
                                    Protecting victims of sudden-impact crashes and related
                                    injuries.
                                </p>
                            </Link>

                            <Link
                                to="/car-accidents"
                                className="related-card"
                            >
                                <h4>Car Accidents</h4>

                                <p>
                                    Representation for accident victims dealing with injuries,
                                    insurance, and recovery.
                                </p>
                            </Link>

                            <Link
                                to="/pedestrian-accident"
                                className="related-card"
                            >
                                <h4>Pedestrian Accident</h4>

                                <p>
                                    Advocating for pedestrians injured due to negligent drivers.
                                </p>
                            </Link>

                            <Link
                                to="/bicycle-accidents"
                                className="related-card"
                            >
                                <h4>Bicycle Accidents</h4>

                                <p>
                                    Legal support for cyclists facing injury, liability, and
                                    compensation challenges.
                                </p>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
            <Footer></Footer>
        </>

    );
};

export default PersonalInjury;
